import { Dispatch, SetStateAction } from 'react';
import ScrollingContainer from 'components/ScrollingContainer';
import List from 'components/Shared/FacetCountList';
import styles from './styles';

interface CheckMenuListProps {
  options: string[];
  selected?: string;
  onSelect?: (selected: string) => void;
  setIsModalOpen?: Dispatch<SetStateAction<boolean>>;
  facetCounts?: Record<string, number>;
}

export default function CheckMenuList({
  options,
  selected,
  onSelect,
  setIsModalOpen,
  facetCounts,
}: CheckMenuListProps): JSX.Element {
  function onClick(val: string): void {
    onSelect?.(val);
    setIsModalOpen?.(false);
  }

  return (
    <>
      <ScrollingContainer className="scrolling-container">
        <List
          options={options}
          className="check-menu-list-modal"
          onClick={onClick}
          labelExtractor={(option): string => option}
          valueExtractor={(option): string => option}
          isSelected={(option): boolean => option === selected}
          ariaLabel="Check menu list options"
          dataTestId="check-menu-options-list"
          facetCounts={facetCounts}
        />
      </ScrollingContainer>
      <style>{styles}</style>
    </>
  );
}
